import { useState } from 'react';

import { NpsSteps } from '@web/components/npsScore/constants';
import { useNpsSurveyContext } from '@web/components/npsScore/NpsSurveyProvider/NpsSurveyProvider';

import { isScorePositive, isBadScore } from '../utils';

type Props = {
  onPositiveRate: () => void;
  submitForm: () => void;
};

export const useNpsScoreSteps = ({ onPositiveRate, submitForm }: Props) => {
  const [step, setStep] = useState(NpsSteps.rate);
  const { npsSurveyFormValues, updateNpsValue } = useNpsSurveyContext();
  const { npsScore, scoreComment, influence } = npsSurveyFormValues;

  const onSetScore = (score: number): void => {
    updateNpsValue({ npsScore: score });

    if (isScorePositive(score)) {
      onPositiveRate();
    }
  };

  const setScoreComment = (comment: string) => {
    updateNpsValue({ scoreComment: comment });
  };

  const nextStep = (): void => {
    setStep((step) => {
      let next = step + 1;

      if (
        next === NpsSteps.finish &&
        (isBadScore(npsScore) || influence === 'Employee scheduling')
      ) {
        next = NpsSteps.finishCall;
      }

      if (next === NpsSteps.finish || next === NpsSteps.finishCall) {
        submitForm();
      }

      return next;
    });
  };

  return {
    scoreComment,
    setScoreComment,
    nextStep,
    npsScore,
    onSetScore,
    step,
    influence,
  };
};
